export default function eventFloating() {
  const floating = document.querySelector(".event-floating");
  if (!floating) return;

  const signup = document.querySelector("#signup");
  if (!signup) return;

  const body = document.querySelector("body");

  const observer = new IntersectionObserver(
    (entries) => {
      entries.forEach((entry) => {
        if (entry.isIntersecting) {
          floating.classList.add("hidden");
          body.classList.remove("event-floating-active");
        } else {
          floating.classList.remove("hidden");
          body.classList.add("event-floating-active");
        }
      });
    },
    { threshold: 0.1 },
  );
  observer.observe(signup);
}
